/**
 * Semnul de langa „Livrat" cand curierul n-a scanat livrarea (Madalin, 21.10.2026). Coletul e
 * livrat — l-a semnat destinatarul —, dar la FAN bara ramane „In livrare", iar cine se uita acolo
 * crede ca n-a ajuns. Pe telefon nu exista hover: unde e loc, textul se scrie si vizibil (`text`).
 */
import { AlertTriangle } from 'lucide-react'

export function mesajFaraScanare(semnat: string | null | undefined): string {
  return `Coletul a fost primit${semnat ? ` (semnat de ${semnat})` : ''}, dar curierul n-a scanat livrarea în urmărire. La curier poate apărea tot „În livrare”.`
}

export function LivratFaraScanare({
  semnat,
  text = false,
}: {
  semnat?: string | null
  /** Și textul, nu doar semnul — unde e loc (pagina comenzii, panoul coletului). */
  text?: boolean
}) {
  const mesaj = mesajFaraScanare(semnat)
  if (text)
    return (
      <span className="mt-0.5 flex items-start gap-1 text-xs text-b4l-amber-dark">
        <AlertTriangle size={13} className="mt-0.5 shrink-0" aria-hidden="true" />
        <span>{mesaj}</span>
      </span>
    )
  return (
    <span
      title={mesaj}
      aria-label={mesaj}
      role="img"
      className="inline-flex cursor-help align-middle text-b4l-amber-dark"
    >
      <AlertTriangle size={13} aria-hidden="true" />
    </span>
  )
}
